import React, { useState } from "react";
import styles from "./arcana-desc-modal.module.css";
import ModalRight from "./modal-right/modal-right";
import getImageFileName from "../../../functions/getImageFileName";
import { LOCALES } from "../../../constants";

const levelFlags = ["level_35", "level_40", "level_45", "level_50"];

export default function ArcanaDescModal({ lang, isActive, setIsActive, selected }) {
    const [levelFlag, setLevelFlag] = useState(localStorage.getItem("level_flag") || "level_50");

    const changeLevelFlag = (flag) => {
        if (!levelFlags.includes(flag)) return;

        localStorage.setItem("level_flag", flag);
        setLevelFlag(flag);
    };

    return (
        <div
            className={`modal overflow ${isActive ? "active" : ""}`}
            onClick={(e) => {
                if (e.target.classList.contains("modal")) {
                    setIsActive(false);
                }
            }}
        >
            <div className="window">
                <button className="close-button" onClick={() => setIsActive(false)}>
                    <i className="fi fi-sr-x" />
                </button>
                <div className="level-buttons">
                    {levelFlags.map((flag, index) => {
                        const level = parseInt(flag.replace("level_", ""));

                        return (
                            <button
                                type="button"
                                className={`${levelFlag === levelFlags[index] ? "active" : ""}`}
                                onClick={() => changeLevelFlag(levelFlags[index])}
                                key={`level_flag_${level}`}
                            >
                                Lv.{level}
                            </button>
                        );
                    })}
                </div>

                {selected && (
                    <div className={styles["illustration"]}>
                        <img src={`${process.env.PUBLIC_URL}/images/cards/${getImageFileName(selected.name[[LOCALES.KO]])}.webp`} />
                    </div>
                )}

                {selected && <ModalRight lang={lang} selected={selected} levelFlag={levelFlag} />}
            </div>
        </div>
    );
}
